import { createApiClient, combineApiConfigs } from '@wix/premium-fed-sdk/@apis-infra-react';
import { PremiumStoreApiConfig } from '@wix/premium-fed-sdk/api-clients';
import { UserOfferingApiAggregations } from './api-configs/user-offering-aggregations.api-config';

// TODO - extract only getUserOffering
export const UserOfferingApiClient = createApiClient(combineApiConfigs(PremiumStoreApiConfig, UserOfferingApiAggregations));
//# sourceMappingURL=user-offering.api-client.js.map